import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Trophy, Crown } from "lucide-react";
import api from "@/lib/api";

const MEDALS = ["#fbbf24", "#cbd5e1", "#d97706"];
const ROW_INITIAL = { opacity: 0, x: -30 };
const ROW_ANIMATE = { opacity: 1, x: 0 };
const ROW_EXIT = { opacity: 0 };
const BAR_INITIAL = { width: 0 };
const BAR_TRANSITION = { duration: 1.2, ease: "easeOut" };

export default function Leaderboard({ contestId, accent = "#f59e0b", refreshMs = 30000, onData }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => fetch(api.leaderboardUrl(contestId)).then((r) => r.json()).then((d) => { if (alive) { setData(d); onData?.(d); } }).catch(() => {});
    load();
    const t = setInterval(load, refreshMs);
    return () => { alive = false; clearInterval(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contestId, refreshMs]);
  if (!data?.stores?.length) return null;
  const max = data.stores[0].wins || 1;
  return (
    <div className="w-full max-w-[70vmin] rounded-[2vmin] bg-black/45 backdrop-blur-md border border-white/15 p-[2.5vmin] text-left" data-testid="display-leaderboard">
      <div className="flex items-center gap-[1vmin] mb-[1.5vmin]">
        <Trophy className="h-[3vmin] w-[3vmin]" style={{ color: accent }} />
        <h2 className="font-display font-bold text-[2.8vmin] leading-none">Classifica punti vendita</h2>
        <span className="ml-auto text-[1.8vmin] text-white/60">{data.total_wins} vincite</span>
      </div>
      <ul className="space-y-[1vmin]">
        <AnimatePresence initial={false}>
          {data.stores.map((s, i) => (
            <motion.li key={s.store} layout initial={ROW_INITIAL} animate={ROW_ANIMATE} exit={ROW_EXIT} transition={{ type: "spring", stiffness: 260, damping: 26, delay: i * 0.06 }}
              className="relative overflow-hidden rounded-[1.2vmin] bg-white/10" data-testid={`leaderboard-row-${i}`}>
              <motion.div className="absolute inset-y-0 left-0 rounded-[1.2vmin]" style={{ background: accent, opacity: 0.35 }} initial={BAR_INITIAL} animate={{ width: `${(s.wins / max) * 100}%` }} transition={BAR_TRANSITION} />
              <div className="relative flex items-center gap-[1.5vmin] px-[1.5vmin] py-[1vmin]">
                <span className="grid place-items-center h-[3.2vmin] w-[3.2vmin] rounded-full font-black text-[1.8vmin] text-slate-900" style={{ background: MEDALS[i] || "rgba(255,255,255,0.7)" }}>
                  {i === 0 ? <Crown className="h-[2vmin] w-[2vmin]" /> : i + 1}
                </span>
                <span className="font-semibold text-[2.2vmin] truncate flex-1">{s.store}</span>
                <span className="font-display font-black text-[2.6vmin]">{s.wins}</span>
              </div>
            </motion.li>
          ))}
        </AnimatePresence>
      </ul>
    </div>
  );
}
